import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { ScheduleInterviewComponent } from './schedule-interview.component';
import { ScheduleInterviewRoutes } from './index';
import { SelectLocationComponent } from './select-location/select-location.component';
import { SelectDateComponent } from './select-date/select-date.component';
import { SelectTimeComponent } from './select-time/select-time.component';
import { ReviewSubmitComponent } from './review-submit/review-submit.component';
import { AppointmentService } from '../shared/services/appointment.service';
import { SelectLocationGuard } from './select-location/select-location.guard';
import { SelectDateGuard } from './select-date/select-date.guard';
import { SelectTimeGuard } from './select-time/select-time.guard';
import { ReviewSubmitGuard } from './review-submit/review-submit.guard';
import { ProgressTrackerService } from '../shared/services/progress-tracker.service';
import { ScheduleRemoteComponent } from './schedule-remote/schedule-remote.component';
import { ScheduleRemoteGuard } from './schedule-remote/schedule-remote.guard';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        TranslateModule,
        RouterModule.forChild(ScheduleInterviewRoutes)
    ],
    declarations: [
        ScheduleInterviewComponent,
        SelectLocationComponent,
        SelectDateComponent,
        SelectTimeComponent,
        ReviewSubmitComponent,
        ScheduleRemoteComponent
    ],
    exports: [
        ScheduleInterviewComponent,
        SelectLocationComponent,
        SelectDateComponent,
        SelectTimeComponent,
        ReviewSubmitComponent,
        ScheduleRemoteComponent
    ],
    providers: [
        AppointmentService,
        // SelectLocationGuard,
        // SelectDateGuard,
        // SelectTimeGuard,
        //ReviewSubmitGuard,
        ProgressTrackerService,
        //ScheduleRemoteGuard
    ]
})
export class ScheduleInterviewModule {}
